import {
  ILoginData,
  isDevBuild,
  isProdBuild,
  isTestBuild,
  loadScript,
} from '@amagimedia/commons';
import LogRocket from 'logrocket';
import type { FC } from 'react';
import { version as bifrostVersion } from '../../../../package.json';

declare global {
  var pendo: any;
}

export const LoadExternalServices: FC<ILoadExternalServicesProps> = ({
  loginData,
}) => {
  if (!loginData) {
    return null;
  }

  // adding google analytics only in dev env
  if (isDevBuild) {
    loadScript(
      'https://www.googletagmanager.com/gtag/js?id=G-N7RT8G0WV8',
      true,
      {
        load: 'async',
        type: '',
        language: '',
      },
      `window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', 'G-N7RT8G0WV8');`,
    );
  }

  if (isTestBuild || isProdBuild) {
    pendo.initialize({
      visitor: {
        id: `${process.env.ENV_TYPE}-${loginData.user_id.toString()}`, // Required if user is logged in, default creates anonymous ID
        // email:        // Recommended if using Pendo Feedback, or NPS Email
        // full_name:    // Recommended if using Pendo Feedback
        // role:         // Optional

        // You can add any additional visitor level key-values here,
        // as long as it's not one of the above reserved names.
      },

      account: {
        id: loginData.account_code.toString(), // Required if using Pendo Feedback, default uses the value 'ACCOUNT-UNIQUE-ID'
        // name:         // Optional
        // is_paying:    // Recommended if using Pendo Feedback
        // monthly_value:// Recommended if using Pendo Feedback
        // planLevel:    // Optional
        // planPrice:    // Optional
        // creationDate: // Optional

        // You can add any additional account level key-values here,
        // as long as it's not one of the above reserved names.
      },
    });
  }

  const shouldUseLogrocket = isProdBuild && process.env.LOGROCKET_KEY;

  if (shouldUseLogrocket) {
    LogRocket.init(process.env.LOGROCKET_KEY!);
  }

  if (!shouldUseLogrocket) {
    return null;
  }

  LogRocket.identify(String(loginData.user_id), {
    name: loginData.user_name,
    email: loginData.user_email_id,
    stvVersion: bifrostVersion,
    subscriptionType: 'pro',
  });

  return null;
};

interface ILoadExternalServicesProps {
  loginData: ILoginData | null;
}
